/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SalesForOnePeriod } from './SalesForOnePeriod';
import {
    SalesForOnePeriodFromJSON,
    SalesForOnePeriodFromJSONTyped,
    SalesForOnePeriodToJSON,
    SalesForOnePeriodToJSONTyped,
} from './SalesForOnePeriod';

/**
 * 
 * @export
 * @interface ICRTouchScheduleSales
 */
export interface ICRTouchScheduleSales {
    /**
     * 
     * @type {Array<SalesForOnePeriod>}
     * @memberof ICRTouchScheduleSales
     */
    sales: Array<SalesForOnePeriod>;
}

/**
 * Check if a given object implements the ICRTouchScheduleSales interface.
 */
export function instanceOfICRTouchScheduleSales(value: object): value is ICRTouchScheduleSales {
    if (!('sales' in value) || value['sales'] === undefined) return false;
    return true;
}

export function ICRTouchScheduleSalesFromJSON(json: any): ICRTouchScheduleSales {
    return ICRTouchScheduleSalesFromJSONTyped(json, false);
}

export function ICRTouchScheduleSalesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICRTouchScheduleSales {
    if (json == null) {
        return json;
    }
    return {
        
        'sales': ((json['sales'] as Array<any>).map(SalesForOnePeriodFromJSON)),
    };
}

  export function ICRTouchScheduleSalesToJSON(json: any): ICRTouchScheduleSales {
      return ICRTouchScheduleSalesToJSONTyped(json, false);
  }

  export function ICRTouchScheduleSalesToJSONTyped(value?: ICRTouchScheduleSales | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sales': ((value['sales'] as Array<any>).map(SalesForOnePeriodToJSON)),
    };
}

